import React, { useRef } from 'react';
import useIsLiteSite from '../../helpers/useIsLiteSite';
import { Page } from '../PageCard';

import styles from './styles.scss';

interface Props {
  page?: Page;
  scrollIntoView?: boolean;
}

const CardContainer: React.FC<Props &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  page,
  scrollIntoView = false,
  ...props
}) => {
  const pageRef = useRef<HTMLDivElement>(null);
  const isLiteSite = useIsLiteSite();

  // Only hide empty pages if lite site and not a custom page
  const hasPageItems = !page?.items.length;
  const notCustomPage = page?.type !== 'CustomPage';
  const isHidden = !!(isLiteSite && page && !page.show && hasPageItems && notCustomPage);

  if (scrollIntoView && pageRef?.current && pageRef.current.scrollIntoView) {
    pageRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div className={`${styles.container} ${isHidden ? styles.hide : ''}`} ref={pageRef} {...props}>
      {children}
    </div>
  );
};

export default CardContainer;
